import { UnitsOfLength } from '@race-planner/aws-amplify/src/models';
import {
    convertMetersToKilometers,
    convertMetersToMiles
} from '@race-planner/unit-converters';

const distanceFromMetersConverters = {
    [UnitsOfLength.METRIC]: value => convertMetersToKilometers(value),
    [UnitsOfLength.STATUTE]: value => convertMetersToMiles(value)
};

export const calculateRunTimeForPace = ({
    paceInSeconds,
    distanceInMeters,
    unitsOfLength
}) => paceInSeconds * distanceFromMetersConverters[unitsOfLength](distanceInMeters);
